import React from 'react'
import { FaChartPie, FaBook, FaCheckCircle, FaEdit, FaGift, FaDollarSign, FaFileAlt, FaQuestionCircle, FaLayerGroup } from 'react-icons/fa'
import './PersonalPerformanceChart.scss'

const PersonalPerformanceChart = ({ analysis }) => {
  if (!analysis) {
    return null;
  }

  const { statistics } = analysis;

  const performanceData = [
    {
      label: 'Published',
      value: statistics.publishedModules,
      total: statistics.totalModules,
      icon: <FaCheckCircle />,
      color: 'success',
      percentage: statistics.totalModules > 0 ? ((statistics.publishedModules / statistics.totalModules) * 100).toFixed(1) : 0
    },
    {
      label: 'Draft',
      value: statistics.draftModules,
      total: statistics.totalModules,
      icon: <FaEdit />,
      color: 'warning',
      percentage: statistics.totalModules > 0 ? ((statistics.draftModules / statistics.totalModules) * 100).toFixed(1) : 0
    },
    {
      label: 'Free Content',
      value: statistics.freeModules,
      total: statistics.totalModules,
      icon: <FaGift />,
      color: 'info',
      percentage: statistics.totalModules > 0 ? ((statistics.freeModules / statistics.totalModules) * 100).toFixed(1) : 0
    },
    {
      label: 'Paid Content',
      value: statistics.paidModules,
      total: statistics.totalModules,
      icon: <FaDollarSign />,
      color: 'secondary',
      percentage: statistics.totalModules > 0 ? ((statistics.paidModules / statistics.totalModules) * 100).toFixed(1) : 0
    }
  ];

  const contentData = [
    {
      label: 'Chapters',
      value: statistics.totalChapters,
      icon: <FaFileAlt />,
      color: 'secondary'
    },
    {
      label: 'Question Banks',
      value: statistics.totalQBanks,
      icon: <FaQuestionCircle />,
      color: 'success'
    },
    {
      label: 'Files',
      value: statistics.totalFiles,
      icon: <FaFileAlt />,
      color: 'info'
    },
    {
      label: 'Flashcard Sets',
      value: statistics.totalFlashcardSets,
      icon: <FaLayerGroup />,
      color: 'warning'
    }
  ];

  return (
    <div className="personal-performance-chart">
      <div className="section-header">
        <h2 className="section-title">My Performance</h2>
        <p className="section-subtitle">Overview of your module creation and content performance</p>
      </div>

      <div className="performance-content">
        {/* Module Status Performance */}
        <div className="performance-section">
          <h3 className="section-subtitle">Module Status Performance</h3>
          <div className="performance-bars">
            {performanceData.map((item, index) => (
              <div key={index} className="performance-item">
                <div className="performance-header">
                  <div className="performance-label">
                    <span className="performance-icon">{item.icon}</span>
                    <span>{item.label}</span>
                  </div>
                  <div className="performance-stats">
                    <span className="performance-value">{item.value}</span>
                    <span className="performance-percentage">{item.percentage}%</span>
                  </div>
                </div>
                <div className="performance-bar-container">
                  <div 
                    className={`performance-bar performance-bar--${item.color}`}
                    style={{ width: `${item.percentage}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Content Creation Performance */}
        <div className="content-section">
          <h3 className="section-subtitle">Content Creation Performance</h3>
          <div className="content-grid">
            {contentData.map((item, index) => (
              <div key={index} className={`content-card content-card--${item.color}`}>
                <div className="content-icon">{item.icon}</div>
                <div className="content-info">
                  <div className="content-value">{item.value}</div>
                  <div className="content-label">{item.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Performance Summary */}
        <div className="summary-section">
          <h3 className="section-subtitle">Performance Summary</h3>
          <div className="summary-grid">
            <div className="summary-card">
              <div className="summary-label">Publication Rate</div>
              <div className="summary-value">
                {statistics.totalModules > 0 ? ((statistics.publishedModules / statistics.totalModules) * 100).toFixed(1) : 0}%
              </div>
            </div>
            <div className="summary-card">
              <div className="summary-label">Free Content Rate</div>
              <div className="summary-value">
                {statistics.totalModules > 0 ? ((statistics.freeModules / statistics.totalModules) * 100).toFixed(1) : 0}%
              </div>
            </div>
            <div className="summary-card">
              <div className="summary-label">Content Creation</div>
              <div className="summary-value">
                {statistics.totalChapters + statistics.totalQBanks + statistics.totalFiles + statistics.totalFlashcardSets}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalPerformanceChart;
